module.exports = __webpack_public_path__ + "assets/icon-checked.c1e9f68c.svg";